import { render } from "./Confirmacao.vue?vue&type=template&id=1395724f&scoped=true"
import script from "./Confirmacao.vue?vue&type=script&lang=js"
export * from "./Confirmacao.vue?vue&type=script&lang=js"

import "./Confirmacao.vue?vue&type=style&index=0&id=1395724f&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1395724f"]])

export default __exports__